module.exports = __webpack_public_path__ + "media/images/icons/medupp-logo-icon-only-red-fd82481458e0a5a17d1695ce2c549c8b.svg";